import React from 'react';

const NotFound = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>404</h1>
            <p>The page you are looking for does not exist.</p>
        </div>
    );
};

export default NotFound;
